// src/services/users.js
import api from "api/axios";

// Liste
export const listUsers = () => api.get("/users/list/");

// Rôles globaux
export const getRoles = () => api.get("/users/roles/");

// Création
export const addUser = (payload) => api.post("/users/add/", payload);

// Set rôle (endpoint dédié existant)
export const setUserRole = (id, roleName) =>
  api.post(`/users/${id}/set-role/`, { global_role: roleName });

// ✅ Suppression (renvoie { ok, error? } pour afficher le bon message)
export const deleteUser = async (id) => {
  try {
    const { status } = await api.delete(`/users/${id}/delete/`);
    return { ok: status === 204 };
  } catch (err) {
    // On essaie de récupérer le message précis du backend
    const msg =
      err?.response?.data?.detail || err?.response?.data?.message || "Failed to delete user.";
    return { ok: false, error: msg };
  }
};

// Détail (GET /users/<id>/)
export const getUser = (id) => api.get(`/users/${id}/`);

// Helper: retourne directement data
export const fetchUser = async (id) => {
  const { data } = await getUser(id);
  return data;
};

// Mise à jour (PATCH /users/<id>/)
export const updateUser = async (id, payload) => {
  // Garde-fou: n’envoyer que email + global_role tant que le backend n’accepte pas plus
  const safe = {};
  if (Object.prototype.hasOwnProperty.call(payload, "email")) safe.email = payload.email;
  if (Object.prototype.hasOwnProperty.call(payload, "global_role")) {
    safe.global_role = payload.global_role ?? null;
  }

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug("[services/users] PATCH /users/%s/ payload:", id, safe);
  }

  const { data } = await api.patch(`/users/${id}/`, safe);
  return data;
};
